import { throwResponse } from "config/axios";
import { axiosProperty } from "config/axios";
import { IResponse } from "config/axios/interface";
import { IParcelSettingType, IParcelSettingTypeParams } from "./interface";
import {
  useInfiniteQuery,
  UseInfiniteQueryResult,
  useMutation,
  UseMutationResult,
  useQuery,
  UseQueryResult,
} from "@tanstack/react-query";

export const useGetParcelSettingTypes = (
  params?: IParcelSettingTypeParams
): UseQueryResult<IResponse<IParcelSettingType[]>, Error> => {
  return useQuery(
    ["parcel-setting-type", "all", params],
    async () => {
      const res = await axiosProperty.get("/parcel-types", { params });
      if (res.status === 200) {
        return res.data;
      }
      throwResponse(res);
    },
    {
      enabled: params?.enabled,
    }
  );
};

export const useScrollGetParcelSettingTypes = (
  params?: IParcelSettingTypeParams
): UseInfiniteQueryResult<IResponse<IParcelSettingType[]>, Error> => {
  return useInfiniteQuery(
    ["parcel-setting-type", "scroll", params],
    async ({ pageParam }) => {
      const res = await axiosProperty.get("/parcel-types", {
        params: { ...params, ...pageParam },
      });
      if (res.status === 200) {
        return res.data;
      }
      throwResponse(res);
    },
    { keepPreviousData: true, enabled: params?.enabled }
  );
};

export const useGetParcelSettingType = (
  id?: string | number
): UseQueryResult<IParcelSettingType, Error> => {
  return useQuery(
    ["parcel-setting-type", "all", id],
    async () => {
      const res = await axiosProperty.get(`/parcel-types/${id}`);
      if (res.status === 200) {
        return res.data.data;
      }
      throwResponse(res);
    },
    {
      enabled: !!id,
    }
  );
};

export const usePostParcelSettingType = (): UseMutationResult<
  unknown,
  Error
> => {
  return useMutation(async (data) => {
    const res = await axiosProperty.post("/parcel-types", data);
    if (res.status === 200) {
      return;
    }
    throwResponse(res);
  });
};

export const usePatchParcelSettingType = (): UseMutationResult<
  unknown,
  Error
> => {
  return useMutation(async ({ id, ...data }: any) => {
    const res = await axiosProperty.patch(`/parcel-types/${id}`, data);
    if (res.status === 200) {
      return;
    }
    throwResponse(res);
  });
};

export const useDeleteParcelSettingType = (): UseMutationResult<
  unknown,
  Error
> => {
  return useMutation(async ({ id }: any) => {
    const res = await axiosProperty.delete(`/parcel-types/${id}`);
    if (res.status === 200) {
      return;
    }
    throwResponse(res);
  });
};

export const useDeleteParcelSettingTypeBulk = (): UseMutationResult<
  unknown,
  Error
> => {
  return useMutation(async (data) => {
    const res = await axiosProperty.delete("/parcel-types/bulk", { data });
    if (res.status === 200) {
      return;
    }
    throwResponse(res);
  });
};


export const useExportExcelPropertyParcelSettings = (): UseMutationResult<Blob> => {
  return useMutation(async (data) => {
    const res = await axiosProperty.post("/export-excel/parcel-types", data, {
      responseType: "blob",
    });
    if (res.status === 200) {
      return res.data;
    }
    throwResponse(res);
  });
};


